// Auto-generated by the Õtekse orchestrator for the live preview. Not committed.
(function () {
  if (typeof window === 'undefined') return;
  var PARENT = "https://orchestrator.xn--tekse-cua.ee";
  var active = false;
  var overlay = null;

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.style.cssText =
      'position:fixed;z-index:2147483647;pointer-events:none;border:2px solid #c9a227;' +
      'background:rgba(201,162,39,.14);border-radius:2px;display:none';
    document.documentElement.appendChild(overlay);
    return overlay;
  }

  function classOf(el) {
    var c = el.className;
    if (c && typeof c === 'object' && 'baseVal' in c) c = c.baseVal;
    return String(c || '').trim();
  }

  function move(e) {
    if (!active) return;
    var el = e.target;
    if (!el || el === overlay) return;
    var r = el.getBoundingClientRect();
    var o = ensureOverlay();
    o.style.display = 'block';
    o.style.left = r.left + 'px';
    o.style.top = r.top + 'px';
    o.style.width = r.width + 'px';
    o.style.height = r.height + 'px';
  }

  function selectorFor(el) {
    var parts = [];
    var node = el;
    var depth = 0;
    while (node && node.nodeType === 1 && depth < 4) {
      var s = node.tagName.toLowerCase();
      if (node.id) { parts.unshift(s + '#' + node.id); break; }
      var cls = classOf(node).split(/\s+/).filter(Boolean).slice(0, 2);
      if (cls.length) s += '.' + cls.join('.');
      parts.unshift(s);
      node = node.parentElement;
      depth++;
    }
    return parts.join(' > ');
  }

  function pick(e) {
    if (!active) return;
    e.preventDefault();
    e.stopPropagation();
    var el = e.target;
    var info = {
      type: 'otk-picked',
      tag: el.tagName.toLowerCase(),
      id: el.id || '',
      classes: classOf(el),
      text: (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 140),
      selector: selectorFor(el),
      html: (el.outerHTML || '').slice(0, 400)
    };
    stop();
    try { window.parent.postMessage(info, PARENT); } catch (err) {}
  }

  function start() {
    active = true;
    document.addEventListener('mousemove', move, true);
    document.addEventListener('click', pick, true);
    if (document.body) document.body.style.cursor = 'crosshair';
  }
  function stop() {
    active = false;
    document.removeEventListener('mousemove', move, true);
    document.removeEventListener('click', pick, true);
    if (overlay) overlay.style.display = 'none';
    if (document.body) document.body.style.cursor = '';
  }

  // Storefront preview override. The frontend reads this cookie only when its
  // preview flag is on, so this can never open the real shop — it just lets the
  // client see both states. Same-origin write, then a reload so the server
  // re-renders (the shop state is decided server-side).
  function setShop(on) {
    document.cookie = 'otk_shop=' + (on ? 'on' : 'off') + ';path=/;max-age=86400;samesite=lax';
    location.reload();
  }

  window.addEventListener('message', function (e) {
    if (e.origin !== PARENT || !e.data) return;
    if (e.data.type === 'otk-pick') { e.data.on ? start() : stop(); }
    else if (e.data.type === 'otk-shop') { setShop(!!e.data.on); }
    // Only this document knows what the client is actually looking at — which
    // page, scrolled where, at what size. The visual check captures exactly
    // that rather than guessing at the top of the homepage.
    else if (e.data.type === 'otk-state') {
      window.parent.postMessage({
        type: 'otk-state-reply',
        path: location.pathname + location.search,
        scrollY: Math.round(window.scrollY),
        width: window.innerWidth,
        height: window.innerHeight
      }, PARENT);
    }
  });

  // Tell the chat which state the preview is actually in, so its toggle can
  // reflect reality after a reload rather than drifting out of sync.
  try {
    var m = document.cookie.match(/(?:^|;\s*)otk_shop=(on|off)/);
    window.parent.postMessage({ type: 'otk-shop-state', on: m ? m[1] === 'on' : null }, PARENT);
  } catch (err) {}
})();
export {};
